import React, { useCallback } from 'react'
import { Box, debounce, TextField } from '@mui/material'

export const SearchFilter = ({ onChange }) => {
  const handleOnChange = useCallback(
    debounce((ev) => {
      const value = ev?.target?.value ?? ''
      onChange && onChange(value)
    }, 500),
    []
  )

  return (
    <Box py={1} display='flex' flexDirection='column'>
      <TextField size='small' onChange={handleOnChange} variant='outlined' label='Search' />
    </Box>
  )
}
